import {
  LOGIN_USER,
  SELECT_PROFILE,
  UPDATE_USER,
  CHANGE_USER_PREFERENCES,
  SET_TIME_TO_COUNT, 
} from "../actions/actions.types";

export interface IUser {
  id: number;
  name: string;
  email: string;
  password: string;
  picture: string;
  customerId: number;
  emailValidated: boolean;
  termAccepted: boolean;
  createIn: string;
  updateIn: string;
  active: boolean;
  hash?: string;
  token?: string;
  device: string | null;
  ip: string | null;
  logPoliceUnitId: number;
  logUserId: number;
  timeToCount: number;
}

const INITIAL_STATE: any = {
  user: null,
  profile: null,
  preferences: null,
  timeToCount: 0,
};

const user = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        user: action.user,
      };
    case SELECT_PROFILE:
      return {
        ...state,
        profile: action.profile,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.user,
      };
    case CHANGE_USER_PREFERENCES:
      return {
        ...state,
        preferences: action.preferences,
      };
    case SET_TIME_TO_COUNT:   
      return {
        ...state,
        timeToCount: action.timeToCount,  
      };  
    default:
      return state;
  }
};

export default user;
